import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import GenericCard from '../generic-card';
import {
  ANIMATION_DURATION,
} from '../../app-constants';

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.onClickHeader = this.onClickHeader.bind(this);
    this.toggleCollapsedClass = this.toggleCollapsedClass.bind(this);
    this.toggleAccordionAnimationCompleteClass = this.toggleAccordionAnimationCompleteClass.bind(this);
    this.collapsed = 'collapsed';
    this.accordionAnimationComplete = 'remove-padding';
    this.heightAuto = 'auto';
    this.activeClass = props.activeClass ? props.activeClass : 'active';
    this.deActiveClass = props.deActiveClass ? props.deActiveClass : 'de-active';
    this.state = {
      animationCompleteClass: props.onLoadcollapse ? this.accordionAnimationComplete : '',
      accordionClassName: props.onLoadcollapse ? this.collapsed : '',
      title: props.title,
      headerComponent: props.headerComponent,
      height: props.onLoadcollapse ? 0 : this.heightAuto,
      activeClass: props.onLoadcollapse ? this.deActiveClass : this.activeClass,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      headerComponent: nextProps.headerComponent,
      title: nextProps.title,
    });
  }

  onClickHeader() {
    this.setState({
      height: !this.state.height ? this.heightAuto : 0,
      activeClass: this.state.activeClass === this.activeClass ? this.deActiveClass : this.activeClass,
    });
  }

  toggleCollapsedClass(animationEvent) {
    // animationEvent is an artefact only produced in a hosted environment
    const notTriggeredByModal = animationEvent === undefined;
    if (notTriggeredByModal) {
      this.setState((prevState) => {
        // when opening the accordion
        if (prevState.accordionClassName === this.collapsed) {
          return {
            accordionClassName: '',
            animationCompleteClass: '',
          };
        }
        // when closing the accordion
        return {
          accordionClassName: this.collapsed,
        };
      });
    }
  }

  toggleAccordionAnimationCompleteClass() {
    this.setState((prevState) => {
      // when opening accordion
      if (prevState.accordionClassName === '') {
        return {
          animationCompleteClass: prevState.accordionClassName,
        };
      }
      // when closing accordion
      return {
        animationCompleteClass: this.accordionAnimationComplete,
      };
    });
  }

  render() {
    const {
      height,
    } = this.state;
    const {
      mainColumnClass = '',
      cardBodyClass,
      accordionWrapperClass = '',
      onClickOnFullAccordionWidth,
    } = this.props;
    const accordionHeader = (
      <React.Fragment>
        <div
          className="row collapse-header"
          onClick={onClickOnFullAccordionWidth ? this.onClickHeader : null}
          role="presentation"
        >
          <div className={`col-12 accordion-title ${mainColumnClass}`}>
            {(this.state.headerComponent) ?
              this.state.headerComponent
              : this.state.title
            }
          </div>
          <div className="col-1 pl-0">
            <div
              className="collapse-indicator"
              onClick={onClickOnFullAccordionWidth ? null : this.onClickHeader}
              role="presentation"
            />
          </div>
        </div>
        <div className="accordion-active-arrow text-center">
          <span className="accordion-active-down-arrow">&nbsp;</span>
        </div>
      </React.Fragment>
    );
    return (
      <React.Fragment>
        <GenericCard
          cardClass={`accordion
            ${accordionWrapperClass}
            ${this.state.accordionClassName}
            ${this.state.animationCompleteClass}
            ${this.state.activeClass}`
          }
          cardBodyClass={cardBodyClass}
          headerComponent={accordionHeader}
          contentComponent={
            <AnimateHeight
              height={height}
              duration={ANIMATION_DURATION}
              onAnimationStart={this.toggleCollapsedClass}
              onAnimationEnd={this.toggleAccordionAnimationCompleteClass}
            >
              <div className="block-content">{this.props.children}</div>
            </AnimateHeight>
          }
        />
      </React.Fragment>
    );
  }
}

export default Accordion;
